import React, { useState } from "react";
import FormField from "./FormField";

const FormTextAreaField = ({
  label,
  name,
  type,
  onChange,
  required = true,
}) => {
  const [invalid, setInvalid] = useState(false);
  const onInvalid = () => setInvalid(true);

  return (
    <FormField label={label} name={name}>
      <textarea
        className={`textarea ${invalid ? "is-danger" : ""}`}
        type={type}
        name={name}
        onChange={onChange}
        id={`input-${name}`}
        required={required}
        onInvalid={onInvalid}
      />
    </FormField>
  );
};

export default FormTextAreaField;
